

































import {Component, Inject, Prop} from "vue-property-decorator";
import {HseGuideline} from "../../modules/models";
import Api from "@/components/sio/Api";
import UserRequired from "@/components/UserRequired";

@Component
export default class HseVerifDialog extends UserRequired {
  @Inject()
  api!: Api;

  @Prop({default: false})
  value!: boolean;

  @Prop()
  guideline!: HseGuideline;

  get model() {
    return this.value;
  }
  set model(v: boolean) {
    this.$emit("input", v);
  }

  close() {
    this.model = false;
  }

  working = false;

  async confirm() {
    this.working = true;
    try {
      await this.api.confirmHseGuideline(this.guideline.id, this.guideline.version);
      this.$emit("at-hseguideline-confirmed", this.guideline.id);
    } finally {
      this.working = false;
      this.close();
    }
  }

}
